// extracted by mini-css-extract-plugin
export default {"wrapper":"LocationPage_wrapper__WJKEO","dataWrapper":"LocationPage_dataWrapper__7l4uu","tabContainer":"LocationPage_tabContainer__Bhx8L"};